export const GENERAL_SETTINGS = "GENERAL_SETTINGS";
export const SERVICE_TYPE_AND_CAPACITY = "SERVICE_TYPE_AND_CAPACITY";
export const MANAGE_SCHEDULE = "MANAGE_SCHEDULE";
export const SERVICE_MENU = "SERVICE_MENU";
export const STAFF_MANAGEMENT = "STAFF_MANAGEMENT";
export const ROLES_AND_PERMISSIONS = "ROLES_AND_PERMISSIONS";
